module.exports = __webpack_public_path__ + "static/media/img-how-qr-code-works-01.68c49a91.svg";